import { render, staticRenderFns } from "./ResumoNew.vue?vue&type=template&id=3ed25394&scoped=true"
import script from "./ResumoNew.vue?vue&type=script&lang=js"
export * from "./ResumoNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ed25394",
  null
  
)

export default component.exports